import * as React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './app';
import reportWebVitals from './reportWebVitals';

// A deployment replaces the hashed Vite chunks. A tab that was already open
// can then request a chunk referenced by its old entry bundle and receive a
// preload error. Reload once to fetch the current entry bundle and its matching
// chunk manifest; avoid an infinite reload if the replacement deployment is
// itself unavailable.
const preloadReloadKey = 'vite-preload-error-reload';
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  if (sessionStorage.getItem(preloadReloadKey)) return;
  sessionStorage.setItem(preloadReloadKey, 'true');
  window.location.reload();
});
window.setTimeout(() => sessionStorage.removeItem(preloadReloadKey), 10_000);

const root = document.getElementById('root');
if (!root) throw new Error('No root element found');

if (root) {
  createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
